module.exports = __webpack_public_path__ + "img/woman-avatar.9f1802d9.png";